/**
 * Supabase client for the Saheeh Admin app. Same Supabase project that the
 * POS uses (the `blacklayers-pos` test backend) so a single admin user works
 * across both surfaces.
 *
 * The anon key is public by design — RLS policies in the database scope every
 * read/write to the authenticated user's tenant.
 */

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL ||
  'https://murxacfdulrkqinlubmz.supabase.co';

const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im11cnhhY2ZkdWxya3Fpbmx1Ym16Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1MDE0NjUsImV4cCI6MjA5NDA3NzQ2NX0.8oPriepwpaq2xs-FYUdTOk9PG5Ry3eVmibYTPvSiw4A';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
